module.exports = __webpack_public_path__ + "img/c-en-05.7bacdeff.png";